// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_PIP_SEARCH_QUERY_STRING
});



// WEBPACK FOOTER //
// ./src/pip/shared/action-creators/search-query-string.js